<template>
  <div id="ShadowQualityProgressPopup">
    <div class="common_view_tit">요청자 정보</div>
    <div class="common_view_list">
      <div class="common_view_item">
        <div>
          <div>작성자</div>
          <div>
            <template v-if="originData.userName != null">{{originData.userName}}</template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>본부</div>
          <div>
            <template v-if="originData.affiliateCode != null">
              <template v-for="afc in afcList" v-if="afc.codeValue === originData.affiliateCode">{{afc.codeName}}</template>
            </template>
            <template v-if="originData.officeCode != null">
              <template v-for="ofc1 in ofc1List" v-if="ofc1.codeValue === (originData.officeCode.length === 5 ? originData.officeCode : originData.officeCode.substring(0, 5))">{{ofc1.codeName}}</template>
              <template v-if="originData.officeCode.length > 5">
                <template v-for="ofc2 in ofc2List" v-if="ofc2.codeValue === originData.officeCode">{{ofc2.codeName}}</template>
              </template>
            </template>
            <template v-if="originData.affiliateCode == null && originData.officeCode == null">-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>전화번호</div>
          <div>
            <template v-if="originData.telephone != null">{{originData.telephone}}</template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>이동전화번호</div>
          <div>
            <template v-if="originData.mobilePhone != null">{{originData.mobilePhone}}</template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
    </div>
    <div class="common_view_tit">요청모뎀 정보</div>
    <div class="common_view_list">
      <div class="common_view_item">
        <div>
          <div>모델명</div>
          <div>
            <template v-if="originData.modelName != null">{{originData.modelName}}</template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>모델번호</div>
          <div>
            <template v-if="originData.serialNum != null">{{originData.serialNum}}</template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>기기번호(계량기 번호)</div>
          <div>
            <template v-if="originData.meterNum != null">{{originData.meterNum}}</template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>요청구분</div>
          <div>
            <template v-if="originData.requestType != null">
              <template v-for="item in srtList" v-if="originData.requestType === item.codeValue">{{item.codeName}}</template>
            </template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>현장담당자(이름)</div>
          <div>
            <template v-if="originData.siteMngName != null">{{originData.siteMngName}}</template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>현장담당자 연락처</div>
          <div>
            <template v-if="originData.siteMngContract != null">{{originData.siteMngContract}}</template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>주소</div>
          <div>
            <template v-if="originData.postalCode != null">
              도로명: ({{originData.postalCode}}) {{originData.addressRoad}} {{originData.addressDetails}}<br>
              지번: ({{originData.postalCode}}) {{originData.addressLot}} {{originData.addressDetails}}
            </template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>상호/건물명</div>
          <div>
            <template v-if="originData.buildingName != null">{{originData.buildingName}}</template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>모뎀위치</div>
          <div>
            <template v-if="originData.modemPos != null">옥내</template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>수신레벨</div>
          <div>
            <template v-if="originData.signalLevel != null">
              <template v-for="item in signalLevelList" v-if="originData.signalLevel === item.codeValue">{{item.codeName}}dbm</template>
            </template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>계량기 상세 위치</div>
          <div>
            <template v-if="originData.meterPos != null">{{originData.meterPos}}</template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>RSRP</div>
          <div>
            <template v-if="originData.rsrp != null">{{originData.rsrp}}</template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
<!--      <div class="common_view_item">-->
<!--        <div>-->
<!--          <div>RSRP</div>-->
<!--          <div class="type_attachment">-->
<!--            <div class="common_form_input_wrap type_file">-->
<!--              <div>-->
<!--                <div>첨부파일1</div>-->
<!--                <div>-->
<!--                  <template v-if="rsrp1Origin != null && rsrp1Origin.length > 0">{{rsrp1Origin}}</template>-->
<!--                  <template v-else>첨부파일 없음</template>-->
<!--                </div>-->
<!--              </div>-->
<!--              <label class="btn_download" @click="downloadFile('/upload/rsrp/' + rsrp1)">다운로드</label>-->
<!--            </div>-->
<!--            <div class="common_form_input_wrap type_file">-->
<!--              <div>-->
<!--                <div>첨부파일2</div>-->
<!--                <div>-->
<!--                  <template v-if="rsrp2Origin != null && rsrp2Origin.length > 0">{{rsrp2Origin}}</template>-->
<!--                  <template v-else>첨부파일 없음</template>-->
<!--                </div>-->
<!--              </div>-->
<!--              <label class="btn_download" @click="downloadFile('/upload/rsrp/' + rsrp2)">다운로드</label>-->
<!--            </div>-->
<!--            <div class="common_form_input_wrap type_file">-->
<!--              <div>-->
<!--                <div>첨부파일3</div>-->
<!--                <div>-->
<!--                  <template v-if="rsrp3Origin != null && rsrp3Origin.length > 0">{{rsrp3Origin}}</template>-->
<!--                  <template v-else>첨부파일 없음</template>-->
<!--                </div>-->
<!--              </div>-->
<!--              <label class="btn_download" @click="downloadFile('/upload/rsrp/' + rsrp3)">다운로드</label>-->
<!--            </div>-->
<!--            <div class="common_form_input_wrap type_file">-->
<!--              <div>-->
<!--                <div>첨부파일4</div>-->
<!--                <div>-->
<!--                  <template v-if="rsrp4Origin != null && rsrp4Origin.length > 0">{{rsrp4Origin}}</template>-->
<!--                  <template v-else>첨부파일 없음</template>-->
<!--                </div>-->
<!--              </div>-->
<!--              <label class="btn_download" @click="downloadFile('/upload/rsrp/' + rsrp4)">다운로드</label>-->
<!--            </div>-->
<!--            <div class="common_form_input_wrap type_file">-->
<!--              <div>-->
<!--                <div>첨부파일5</div>-->
<!--                <div>-->
<!--                  <template v-if="rsrp5Origin != null && rsrp5Origin.length > 0">{{rsrp5Origin}}</template>-->
<!--                  <template v-else>첨부파일 없음</template>-->
<!--                </div>-->
<!--              </div>-->
<!--              <label class="btn_download" @click="downloadFile('/upload/rsrp/' + rsrp5)">다운로드</label>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
      <div class="common_view_item">
        <div>
          <div>KAMI</div>
          <div class="type_attachment">
            <div class="common_form_input_wrap type_file">
              <div>
                <div>첨부파일1</div>
                <div>
                  <template v-if="kamiOrigin != null && kamiOrigin.length > 0">{{kamiOrigin}}</template>
                  <template v-else>첨부파일 없음</template>
                </div>
              </div>
              <label class="btn_download" @click="downloadFile('/upload/kami/' + kami)">다운로드</label>
            </div>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>건물주/담당자 특이사항</div>
          <div>
            <template v-if="originData.ownerMemo != null">{{originData.ownerMemo}}</template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>건물 담당자 연락처</div>
          <div>
            <template v-if="originData.ownerContact != null">{{originData.ownerContact}}</template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>문제점 및 현상</div>
          <div>
            <template v-if="originData.issueCode != null">
              <template v-for="item in iscList" v-if="originData.issueCode === item.codeValue">{{item.codeName}}</template>
            </template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>기타사항</div>
          <div>
            <template v-if="originData.etcMemo != null">{{originData.etcMemo}}</template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
    </div>
    <div class="common_view_tit">처리사항 등록</div>
    <div class="common_view_list type_form">
      <div class="common_view_item">
        <div>
          <div>처리날짜<span class="fc_red">*</span></div>
          <div class="datepicker_wrap">
            <vue-datepicker-local
              v-model="procDate"
              inputClass="vdl_input"
              :local="ko"
              :disabled="mySession.userRole !== 4"/>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>조치내역<span class="fc_red">*</span></div>
          <div>
            <select class="type_form_width_50" v-model="action" :disabled="mySession.userRole !== 4">
              <option value="">-- 선택 --</option>
              <option v-for="item in actList" :key="'sqat_' + item.codePid" :value="item.codeValue">{{item.codeName}}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>조치기타내용</div>
          <div>
            <textarea v-model="actionDesc" :readonly="mySession.userRole !== 4"/>
          </div>
        </div>
      </div>
    </div>
    <div class="common_bottom_wrap padding_wrap">
      <div class="btn_bottom btn_close" @click="hidePopup">닫기</div>
      <div class="btn_bottom btn_blue_t" @click="saveShadowQuality" v-if="popupParams.type === 'P' && mySession.userRole === 4">등록(선택)</div>
    </div>
  </div>
</template>

<script>
import common from '../../script/common'
import shadowQuality from '../../script/shadowQuality'
import VueDatepickerLocal from 'vue-datepicker-local'
import {defaultLoadingOptions} from '../../script/defaultConfig'

export default {
  props: ['popupParams'],
  components: {VueDatepickerLocal},
  data () {
    return {
      // Common
      mySession: {},
      ko: common.getDatepickerLocal(),
      // Return
      searchParams: {},
      // Common Data
      afcList: [],
      ofcList: [],
      ofc1List: [],
      ofc2List: [],
      srtList: [],
      signalLevelList: common.getSQSignalLevelList(),
      iscList: [],
      actList: [],
      // Data
      originData: {},
      sqPid: '',
      // rsrp1Origin: '',
      // rsrp1: '',
      // rsrp2Origin: '',
      // rsrp2: '',
      // rsrp3Origin: '',
      // rsrp3: '',
      // rsrp4Origin: '',
      // rsrp4: '',
      // rsrp5Origin: '',
      // rsrp5: '',
      kamiOrigin: '',
      kami: '',
      procDate: '',
      action: '',
      actionDesc: ''
    }
  },
  mounted () {
    this.originData = this.popupParams.data
    common.getSession(response => {
      if (response.data.resultCode === 1 && response.data.result != null && response.data.result.userPid != null && response.data.result.userRole != null) {
        this.mySession = response.data.result
        let intervalCnt = 0
        let interval = setInterval(() => {
          if (common.checkValidateData('session', sessionStorage.getItem('afcList')) &&
            common.checkValidateData('session', sessionStorage.getItem('ofcList')) &&
            common.checkValidateData('session', sessionStorage.getItem('srtList')) &&
            common.checkValidateData('session', sessionStorage.getItem('iscList')) &&
            common.checkValidateData('session', sessionStorage.getItem('actList'))) {
            clearInterval(interval)
            this.afcList = JSON.parse(sessionStorage.getItem('afcList'))
            this.ofcList = JSON.parse(sessionStorage.getItem('ofcList'))
            this.ofc1List = this.getOfc1List()
            if (this.originData.officeCode != null && this.originData.officeCode.length > 5) {
              this.getOfc2List()
            }
            this.srtList = JSON.parse(sessionStorage.getItem('srtList'))
            this.iscList = JSON.parse(sessionStorage.getItem('iscList'))
            this.actList = JSON.parse(sessionStorage.getItem('actList'))
            this.updateData()
          } else if (intervalCnt > 10) {
            clearInterval(interval)
            common.amsAlert('retry', '필수 데이터를 불러오지 못했습니다.')
          } else {
            intervalCnt++
          }
        }, 200)
      } else {
        common.amsAlert('general', '로그아웃 되었습니다.\n다시 로그인해주세요.')
        this.$router.replace('/Login')
      }
    })
  },
  watch: {
    popupParams () {
      this.originData = this.popupParams.data
    }
  },
  methods: {
    hidePopup (args) {
      this.$emit('hidePopup', args)
    },
    getOfc1List () {
      return this.ofcList.filter(item => { return item.codeLevel === 0 })
    },
    getOfc2List () {
      this.ofc2List = this.ofcList.filter(item => { return item.codeParent === this.originData.officeCode.substring(0, 5) })
    },
    updateData () {
      const data = this.popupParams.data
      if (!data.hasOwnProperty('sqPid') || data.sqPid == null) {
        return
      }
      this.sqPid = data.sqPid
      // this.rsrp1Origin = data.rsrp1 != null ? common.getOriginalFileName(data.rsrp1) : ''
      // this.rsrp1 = data.rsrp1 != null ? data.rsrp1 : ''
      // this.rsrp2Origin = data.rsrp2 != null ? common.getOriginalFileName(data.rsrp2) : ''
      // this.rsrp2 = data.rsrp2 != null ? data.rsrp2 : ''
      // this.rsrp3Origin = data.rsrp3 != null ? common.getOriginalFileName(data.rsrp3) : ''
      // this.rsrp3 = data.rsrp3 != null ? data.rsrp3 : ''
      // this.rsrp4Origin = data.rsrp4 != null ? common.getOriginalFileName(data.rsrp4) : ''
      // this.rsrp4 = data.rsrp4 != null ? data.rsrp4 : ''
      // this.rsrp5Origin = data.rsrp5 != null ? common.getOriginalFileName(data.rsrp5) : ''
      // this.rsrp5 = data.rsrp5 != null ? data.rsrp5 : ''
      this.kamiOrigin = data.kami != null ? common.getOriginalFileName(data.kami) : ''
      this.kami = data.kami != null ? data.kami : ''
      this.procDate = data.procDate != null ? new Date(data.procDate) : ''
      this.action = data.action != null ? data.action : ''
      this.actionDesc = data.actionDesc != null ? data.actionDesc : ''
    },
    saveShadowQuality () {
      if ((this.mySession.subRole & 4) === 0) {
        common.amsAlert('general', '권한이 없습니다.')
        return
      }
      const result = common.checkUserRole(this.mySession, 4, 'add')
      if (!result.code) {
        return
      }
      if (!common.checkValidateData('date', this.procDate)) {
        common.amsAlert('general', '처리날짜를 선택해주세요.')
        return
      }
      if (!common.checkValidateData('string', this.action)) {
        common.amsAlert('general', '조치내역을 선택해주세요.')
        return
      }
      let data = {
        procDate: common.getFormattedDate(this.procDate),
        action: this.action
      }
      if (common.checkValidateData('string', this.actionDesc)) {
        if (!common.checkValidateLength('max', this.actionDesc, 1024)) {
          common.amsAlert('general', '조치기타내용이 너무 깁니다.')
          return
        }
        data.actionDesc = this.actionDesc
      }
      const checkedData = common.checkChangedData(data, this.originData)
      if (Object.keys(checkedData).length > 0) {
        checkedData.sqPid = this.originData.sqPid
      } else {
        common.amsAlert('general', '수정된 내용이 없습니다.')
        return
      }
      console.log(checkedData)
      let vueLoadingOverlay = this.$loading.show(defaultLoadingOptions)
      shadowQuality.proc(checkedData, response => {
        console.log('[음영∙품질 개선] 처리사항 등록/수정', response)
        vueLoadingOverlay.hide()
        if (response.data.resultCode === 1) {
          common.amsAlert('general', '처리사항을 저장했습니다.')
          this.hidePopup({type: 'L'})
        } else {
          common.amsAlert('retry', '처리사항을 저장하지 못했습니다.')
        }
      })
    }
  }
}
</script>

<style scoped>
#ShadowQualityProgressPopup .common_bottom_wrap > .btn_bottom {
  height: 46px;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 46px;
}

#ShadowQualityProgressPopup .common_bottom_wrap > .btn_close {
  width: 76px;
  margin: auto auto auto 0;
  color: #36414F;
}

#ShadowQualityProgressPopup .type_form > .common_view_item > div > div:nth-child(2) {
  display: flex;
  padding-left: 0;
}

#ShadowQualityProgressPopup .type_form > .common_view_item > div > div:nth-child(2) > .type_form_width_100 {
  width: 100%;
}

#ShadowQualityProgressPopup .type_form > .common_view_item > div > div:nth-child(2) > .type_form_width_75 {
  width: 75%;
}

#ShadowQualityProgressPopup .type_form > .common_view_item > div > div:nth-child(2) > .type_form_width_50 {
  width: 50%;
}

#ShadowQualityProgressPopup .common_view_item > div > div:nth-child(2).type_attachment {
  display: flex;
  flex-direction: column;
  padding: 7px 26px 7px 0;
  gap: 15px;
}

#ShadowQualityProgressPopup .type_attachment > .common_form_input_wrap.type_file {
  display: flex;
  gap: 12px;
}

#ShadowQualityProgressPopup .type_attachment > .common_form_input_wrap.type_file > div {
  flex-shrink: 1;
  width: 100%;
  height: 36px;
  box-sizing: border-box;
}

#ShadowQualityProgressPopup .type_attachment > .common_form_input_wrap.type_file > div > div {
  font-size: 12px;
}

#ShadowQualityProgressPopup .type_attachment > .common_form_input_wrap.type_file > div > div:nth-child(1) {
  flex-shrink: 0;
}

#ShadowQualityProgressPopup .type_attachment > .common_form_input_wrap.type_file > div > div:nth-child(2) {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  word-break: break-all;
  text-overflow: ellipsis;
  text-align: right;
}

#ShadowQualityProgressPopup .type_attachment > .common_form_input_wrap.type_file > .btn_upload,
#ShadowQualityProgressPopup .type_attachment > .common_form_input_wrap.type_file > .btn_delete,
#ShadowQualityProgressPopup .type_attachment > .common_form_input_wrap.type_file > .btn_download {
  flex-shrink: 0;
  width: 67px;
  height: 36px;
  margin: 0;
  box-sizing: border-box;
  font-size: 12px;
  line-height: 34px;
}
</style>



// WEBPACK FOOTER //
// src/components/shadowQuality/ShadowQualityProgressPopup.vue